import React, {Fragment, useState} from "react";
import Icon, {ICONS} from "patient-ping-remedy/packages/icon";
import {css} from "@emotion/css";
import {sizes} from "patient-ping-remedy/packages/theme";
import {IconWrapper, TitleWrapper} from "@common/CustomExpandMoreButton.styles";

type Props = {
    arrowPosition?: 'left' | 'right';
    title: React.ReactNode;
    children: React.ReactNode;
};

const CustomExpandMoreButton = (props: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const arrowNode = isOpen ?
    <Icon className={css({padding: '0.2rem'})} iconClass={ICONS["angle-up"]} iconSize={"2x"} weight={"far"}/> :
    <Icon className={css({padding: '0.2rem'})} iconClass={ICONS["angle-down"]} iconSize={"2x"} weight={"far"}/>;

  return <Fragment>
    <TitleWrapper onClick={() => setIsOpen(prev => !prev)}>
      {(!props.arrowPosition || props.arrowPosition === 'left') &&
        <IconWrapper margin={`0 ${sizes.xSmall} 0 0`}> {arrowNode} </IconWrapper>}

      {props.title}

      {props.arrowPosition === 'right' &&
        <IconWrapper margin={`0 0 0 ${sizes.xSmall}`}> {arrowNode} </IconWrapper>}
    </TitleWrapper>

    {isOpen && <div className={css({marginTop: sizes.xxSmall})}>{props.children}</div>}
  </Fragment>;
};

export default CustomExpandMoreButton;
